import { CallManager } from "./CallManager";
import { isResultTrue } from "./Core";
import * as I18nKeysShared from "./Locales/shared-map.json";
import { i18n } from "./I18n";

export interface WebMethodResponseMessage {
    d: any;
}

export interface WebMethodResult {
    result: boolean;
}

export interface WebMethodOptions {
    async?: boolean;
    onConnectionError?: (message: string, jqXHR: JQueryXHR, textStatus: string, errorThrown: string) => void;
    timeout?: number;
}

export class WebMethod {
    constructor(protected async: boolean) { }

    /**
     * Uitvoeren van een webmethod.
     * @param params Een object met de volgende eigenschappen:
     * - name: de webmethodnaam,
     * - param: De argumenten voor de webmethod
     * - options: De opties voor de webmethod
     * @returns Een deferred die zowel voor de promise als voor de resolve/reject kan worden gebruikt.
     * De promise wordt geresolved met het resultset, mits resultset.result = true. Anders wordt deze gereject.
     * Ook als de ajax call faalt wordt de promise gereject
     */
    protected static invoke<T>(params: { name: string, param?: any, options?: WebMethodOptions }): JQueryDeferred<T>;
    protected static invoke<T>(params: { name: string, options?: WebMethodOptions }): JQueryDeferred<T>;
    protected static invoke<T>(params: any): JQueryDeferred<T> {
        let deferred: JQueryDeferred<T> = $.Deferred();

        let ajax = CallManager.execute(params.name, params.param, params.options);

        ajax.done((msg: WebMethodResponseMessage, _textStatus: string, jqXHR: JQueryXHR) => {
            let resultset = msg.d;
            if (isResultTrue(resultset)) {
                deferred.resolve(resultset);
            }
            else {
                deferred.reject(resultset, { jqXHRStatus: jqXHR.status });
                console.error(params.name + " " + resultset.message);
            }
        });

        ajax.fail((jqXHR: JQueryXHR, textStatus: string, _errorThrown: string) => {
            let message = GetTextStatus(textStatus, jqXHR.status);
            deferred.reject({ message: message }, { jqXHRStatus: jqXHR.status });
            console.error(params.name + " " + message);
        });

        // Als de deferred wordt gereject dan ook ajax aborten
        deferred.fail(() => {
            if (ajax.readyState != 4) {
                ajax.abort();
            }
        });

        return deferred;
    }
}

/**
     * De statustekst bepalen.
     * @param textStatus De originele statustekst
     * @param jqXHRStatus De jqXHR statuscode
     * @returns Een statustekst
     */
export function GetTextStatus(textStatus: string, jqXHRStatus: number): string {
    if (textStatus === "error" && jqXHRStatus === 0) {
        return i18n.t(I18nKeysShared.request.message.error.connection);
    } else {
        return textStatus;
    }
}
